import PropTypes from "prop-types";
import React from "react";

export default function CustomButton({ block }) {
  const blockData = block.getData();

  const buttonText = blockData.get("buttonText");
  const buttonURL = blockData.get("buttonURL");
  const buttonColor = blockData.get("buttonColor");
  const buttonTextColor = blockData.get("buttonTextColor");
  const buttonBorderColor = blockData.get("buttonBorderColor");
  const buttonWidth = blockData.get("buttonWidth");
  const buttonTargetBlank = blockData.get("buttonTargetBlank");

  return (
    <div
      css={{
        marginTop: 10,
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <a
        href={buttonURL}
        target={buttonTargetBlank ? "_blank" : "_self"}
        rel="noreferrer"
        type="button"
        css={{
          margin: 0,
          padding: "5px 15px",
          color: buttonTextColor,
          fontSize: 20,
          letterSpacing: 0.6,
          backgroundColor: buttonColor,
          border: "1px solid",
          borderColor: buttonBorderColor,
          borderRadius: 4,
          minWidth: 200,
          width: buttonWidth ? `${buttonWidth}%` : undefined,
          textDecoration: "none",
        }}
      >
        {buttonText}
      </a>
    </div>
  );
}

CustomButton.propTypes = {
  block: PropTypes.object.isRequired,
};
